import { createContext, useState } from "react";

export const VendasContext = createContext();

export const VendasProvider = ({ children }) => {



    const [sales, setSales] = useState(null); // Estado que armazena a lista de Vendas
    const [integrations, setIntegrations] = useState([]); // Estado que armazena a lista de Integrações
    const [search, setSearch] = useState("");
    const [startDateFilter, setStartDateFilter] = useState("");
    const [endDateFilter, setEndDateFilter] = useState("");
    const [statusFilter, setStatusFilter] = useState("");
    const [groupProductsFilter, setGroupProductsFilter] = useState("");
    const [integrationFilter, setIntegrationFilter] = useState([]);
    const [plataformFilter, setPlatformFilter] = useState([]);
    const [groupProducts, setGroupProducts] = useState([]);
    const [totalProductsSalesCard, setTotalProductsSalesCard] = useState(0);
    const [totalValueCard, setTotalValueCard] = useState(0);
    const [totalValueProducerCard, setTotalValueProducerCard] = useState(0);
    const [totalProductsRefundedCard, setTotalProductsRefundedCard] = useState(0);
    const [totalValueRefundedCard, setTotalValueRefundedCard] = useState(0);
    const [totalValueRefundedProducerCard, setTotalValueRefundedProducerCard] = useState(0);
    const [report, setReport] = useState(null);

    const [itemsPerPage, setItemsPerPage] = useState(10); // Estado que armazena a quantidade de Itens por Página
    const [currentPage, setCurrentPage] = useState(1); // Estado que armazena qual é a Página Atual que está sendo apresentada
    const [totalItems, setTotalItems] = useState(0);


    return (
        <VendasContext.Provider value={{
            sales, setSales, search, setSearch, startDateFilter, setStartDateFilter, endDateFilter, setEndDateFilter, statusFilter, setStatusFilter, groupProductsFilter, setGroupProductsFilter, groupProducts, setGroupProducts,
            totalProductsSalesCard, setTotalProductsSalesCard, totalValueCard, setTotalValueCard, totalValueProducerCard, setTotalValueProducerCard, totalProductsRefundedCard, setTotalProductsRefundedCard, totalValueRefundedCard, setTotalValueRefundedCard,
            itemsPerPage, setItemsPerPage, currentPage, setCurrentPage, totalItems, setTotalItems, integrationFilter, setIntegrationFilter, plataformFilter, setPlatformFilter, integrations, setIntegrations, totalValueRefundedProducerCard, setTotalValueRefundedProducerCard,
            report, setReport
        }}>
            {children}
        </VendasContext.Provider>
    );
};
